<template>
  <div>
    <div class="card">
      <base-crud
        class="crud"
        crudName="Usuários"
        newText="Novo Usuário"
        :table="usersTable"
        :columns="columns"
        :options="options"
        :endPoint="endPoint"
        :enableAdd="true"
        :enableEdit="true"
        :enableDelete="true"
        :enableView="false"
        :extra="extra"
      ></base-crud>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      usersTable: "usersTable",
      users: [],
      pages: [],
      url: "",
      columns: ["id", "name", "email", "type_access", "actions"],
      tableData: [],
      options: {
        filterByColumn: true,
        filterable: ["id", "name", "email"],
        debounce: 1000,
        sortable: ["id", "name", "email"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        templates: {
          type_access: function (h, row, index) {
            switch (row.type_access){
              case 1:
                return 'Solicitante de Atendimentos'
                break;
              case 2:
                return 'Gestor de Atendimentos'
                break;
              case 3: 
                return 'Administrador'
                break;
              case 4:
                return 'Colaborador'
                break
            }

          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);

          requestData.params = data;

          if (
            this.$parent.$parent.retreat_date != null &&
            this.$parent.$parent.retreat_date != ""
          ) {
            requestData.params.retreat_date = this.$parent.$parent.retreat_date;
          }

          requestData.params.query = "";
          requestData.params.with = [""];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        headings: {
          name: "Nome",
          email: "E-mail",
          type_access: "Tipo de Acesso",
          actions: "Ações",
        },
      },
      endPoint: "users/",
      extra: [],
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    isWeb(){
      if(this.$store.getters.mode == 'fluig'){
        return false;
      }
      return true;
    },
    postUrl() {
      return this.$store.getters.api + this.endPoint;
    },
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        email: "email",
        type_access: "type_access",
      };

      let filters = "";

      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Crud.vue